import { useTranslation } from 'react-i18next';

export default function PrixTypiques() {
  const { t } = useTranslation('saintnicolas');

  return (
    <section className="py-14 md:py-20 bg-soft-gray">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-slate-primary text-center mb-10 md:mb-14">
          {t('prix_h2')}
        </h2>

        <div className="bg-white rounded-lg overflow-hidden">
          {/* Header */}
          <div className="grid grid-cols-2 bg-slate-primary text-white">
            <div className="px-4 md:px-6 py-3 md:py-4 text-sm md:text-base font-semibold border-r border-white/10">
              {t('prix_table_type')}
            </div>
            <div className="px-4 md:px-6 py-3 md:py-4 text-sm md:text-base font-semibold">
              {t('prix_table_price')}
            </div>
          </div>

          {/* Rows */}
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-soft-gray' : 'bg-white'} border-b border-gray-100 last:border-b-0`}
            >
              <div className="px-4 md:px-6 py-3 md:py-4 text-sm text-gray-700 border-r border-gray-100">
                {t(`prix_row_${i}_type`)}
              </div>
              <div className="px-4 md:px-6 py-3 md:py-4 text-sm font-semibold text-slate-primary">
                {t(`prix_row_${i}_price`)}
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs md:text-sm text-gray-500 text-center mt-4 md:mt-5 italic">
          {t('prix_note')}
        </p>
      </div>
    </section>
  );
}